import { Component, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';
import { __values } from 'tslib';
import { fixDropdownAudioEye } from '@/utils/domUtils';

const DropdownProps = Vue.extend({
  props: {
    classWrapper: { type: String, default: 'select-wrapper' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    searchable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    dropdownOptions: { type: Array, default: () => [] },
    customiseClass: { type: String, default: '' },
    selected: { type: [Object, String], default: null },
    errorMessage: { type: String, default: '' },
    error: { type: Boolean, default: false },
    htmlFor: { type: String },
  },
});

@Component({
  components: {
    vSelect,
  },
})
export default class Dropdown extends DropdownProps {
  mounted() {
    let input = document.getElementById(this.placeholder);
    input.setAttribute('role', 'menuitem');

    fixDropdownAudioEye(this.$el, this.dropdownOptions.slice(0, 2), this.clearable)
  }
  fixUlOnClose() {
    setTimeout(() => {
      fixDropdownAudioEye(this.$el, this.dropdownOptions.slice(0, 2), this.clearable)
    }, 500);
  }
}
